module.exports = __webpack_public_path__ + "img/hof_3.0f891a4a.jpg";